











const MAX_NOTES = 35;

import Vue from "vue";
import NoteItem from "./NoteItem.vue";
import { Note, CellDirection } from "../../services/vo";
export default Vue.extend({
  components: {
    NoteItem,
  },
  props: {
    notes: {
      type: Array as () => Array<Note>,
      default: new Array<Note>(),
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      pNotes: new Array<Note>(),
      notesUpdate: 0,
    };
  },
  created() {
    this.pNotes = this.notes;
    if (this.pNotes.length === 0 && !this.readonly) {
      const note = new Note();
      note.text =
        "(EXEMPEL) Vilken duo ligger bakom originalet? Deras efternamn går in på Vågrätt 3 och Lodrätt 4";
      note.track = "(EXEMPEL) The Sound of Silence - Disturbed";
      note.celldir = [
        new CellDirection(3, "vågrätt"),
        new CellDirection(4, "lodrätt"),
      ];
      this.pNotes.push(note);
    }
  },
  computed: {
    puzzleNotes: function (): Note[] {
      return this.pNotes;
    },
  },
  methods: {
    addNote: function (): void {
      if (this.pNotes.length >= MAX_NOTES) return;
      this.pNotes.push(new Note());
      try {
        this.$nextTick(() => {
          const node = document.getElementsByClassName("notes-panel")[0];
          node.scrollTop = node.scrollHeight;
        });
      } catch (err) {
        //console.error(err);
        return;
      }
    },
    deleteNote: function (index: number): void {
      try {
        const self = this;
        setTimeout(() => {
          self.pNotes.splice(index, 1);
          self.notesUpdate += 1;
        }, 250);
        this.$nextTick(() => { });
      } catch (error: any) {
        console.error(error);
        return;
      }
    },
    getNotes: function (): Note[] {
      return this.pNotes;
    },
  },
});
